/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import { Drawer, Card, Form, Row, Col, Select, Checkbox } from 'antd';
import ActionButtonsBar from '@ui/ActionButtonsBar'
import Loading from '../../../../../../components/Loading'
import { getOTACodes } from '../../../../../../services/common'
import Input from '../../../../../ui/Input';
import { LocalPersistence } from "../../../../../../factories";
import { updateMeetingRoomService, addMeetingRoomService, deleteMeetingRoomService } from '../../../../../../services/meetingrooms'
import styles from '../../../index.module.css'

interface editAmenityProps {
  onClose: () => void;
  visible: boolean;
  setOperation: (a: string) => void;
  setCurrentRow: (a: []) => void;
  setDefKey: (a: string) => void;
  setSingleAmenity: (a: any) => void;
  setDataSource: (a: any) => void;
  currentRow: [] | any;
  name: string;
  data: { roomid: number, roomlangid: number, service: [] };
  meetingroomsid: number;
  setCurrentLine: (a: any) => void;
}

const ServiceModal = (props: editAmenityProps) => {
  const [form] = Form.useForm()
  const [disableFlag, setDisableFlag] = useState<boolean>(false)
  const [mrcData, setMrfData] = useState<object[]>([])
  const [chgUnitData, setChgUnitData] = useState<object[]>([])
  const [chgFrequencyData, setChgFrequencyData] = useState<object[]>([])
  const [curData, setCurData] = useState<object[]>([])
  const [ready, setReady] = useState(false);
  const [chargeType, setChargeType] = useState('')
  const { Option } = Select;

  const getMRCdata = async () => {
    let res = await getOTACodes('MRC', '')
    let rest = res?.otacodes || []
    setMrfData(rest)
  }
  const getCHGFrequencydata = async () => {
      let res = await getOTACodes('CHG', 'ChargeFrequency')
      let rest = res?.otacodes || []
      setChgFrequencyData(rest)
  }
  const getCHGChargeUnit = async () => {
    let res = await getOTACodes('CHG', 'ChargeUnit')
      let rest = res?.otacodes || []
      setChgUnitData(rest)
  }
  const getCURdata = async () => {
      let res = await getOTACodes('CUR', '')
      let rest = res?.otacodes || []
      setCurData(rest)
  }

  const saveCapacity = async () => {
    setDisableFlag(true)
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    form.validateFields()
      .then(async (value: any) => {
      let serviceArr: any = []

      if (Object.keys(props.currentRow).length > 0) {
        serviceArr = props.data.service
        props.data.service.map((item: any, index: number) => {
          if (item.serviceid === props.currentRow.serviceid) {
            return serviceArr[index] = {
              capacityid: props.currentRow.serviceid,
              ...value
            }
          }
          return false
        })
      } else {
        serviceArr.push(value)
      }

      let bodyQuery = {
          "supplier": session.supplier,
          "propertyId": session.propertyId,
          "property": {
              "meetingrooms": {
                  "meetingroomsid": props.meetingroomsid,
                  "meetingroom": [
                      {
                          "roomid": props.data.roomid,
                          "roomlangid": props.data.roomlangid,
                          "service": serviceArr
                      }
                  ]
              }
          }
      }

      if (Object.keys(props.currentRow).length > 0) {
        updateMeetingRoomService(bodyQuery)
          .then(res => {
            const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
            props.setDataSource(mtroom.service)
            props.setCurrentLine(mtroom)
            setDisableFlag(false)
            props.onClose()
        })
        .catch(() => setDisableFlag(false))
      } else {
        addMeetingRoomService(bodyQuery)
          .then(res => {
            const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
            props.setDataSource(mtroom.service)
            props.setCurrentLine(mtroom)
            setDisableFlag(false)
            props.onClose()
          })
          .catch(() => setDisableFlag(false))
      }
    })
    .catch(() => setDisableFlag(false))
  }

  const deleteService = async () => {
    setDisableFlag(true)
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    let bodyQuery = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
          "meetingrooms": {
              "meetingroomsid": props.meetingroomsid,
              "meetingroom": [
                  {
                      "roomid": props.data.roomid,
                      "roomlangid": props.data.roomlangid,
                      "service": [{ 
                        "serviceid":props.currentRow.serviceid,
                        "servicelangid": props.currentRow.servicelangid 
                      }]
                  }
              ]
          }
      }
    }

    deleteMeetingRoomService(bodyQuery)
    .then(res => {
      const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
            props.setDataSource(mtroom.service)
            props.setCurrentLine(mtroom)
            setDisableFlag(false)
            props.onClose()
    })
    .catch(() => setDisableFlag(false))
  }

  useEffect(() => {
    if (props.visible) {
      getMRCdata()
      getCHGFrequencydata()
      getCHGChargeUnit()
      getCURdata()
      setTimeout(() => setReady(true), 300)
      setDisableFlag(false)
      if (props.currentRow?.chargetype) {
        setChargeType(props.currentRow?.chargetype)
      }
    } else {
      form.resetFields();
      setReady(false);
      setChargeType('')
    }
  }, [props.visible])

  return (
    <>
       <Drawer
       title={`${props.name} - Capacity`} 
       placement="right" 
       onClose={props.onClose} 
       visible={props.visible} 
       width={976} 
       afterVisibleChange={() => {
         form.setFieldsValue({ 
          charge: props.currentRow?.charge,
          chargetype: props.currentRow?.chargetype,
          currency: props.currentRow?.currency,
          frequency: props.currentRow?.frequency,
          name: props.currentRow?.name,
          quantity: props.currentRow?.quantity,
          serviceid: props.currentRow?.serviceid,
          servicelangid: props.currentRow?.servicelangid,
          type: props.currentRow?.type,
          typedetail: props.currentRow?.typedetail,
          unit: props.currentRow?.unit
          }); 
       }}>
        { ready && <Card style={{ marginTop: -15, marginBottom: 65 }}> 
          <Form
            layout='vertical'
            form={form}
            name='basic'
            >
            <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Service Name'
                name='name'
                rules={[
                  {
                    max: 128,
                    message:
                      'You have reached the max character length of 128',
                  },
                ]}>
                <Input maxLength={128} />
              </Form.Item>
            </Col>
            <Col span={13}>
            <Form.Item
              label='Service Type'
              name='type'>
              <Select allowClear showSearch>
                {mrcData.map((item: any) => {
                  return (
                    <Option
                      key={item.codeName}
                      value={item.codeName}>
                      {item.codeName}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label='Type Detail'
                name="typedetail"
                rules={[
                  {
                    max: 128,
                    message:
                      'You have reached the max character length of 128',
                  },
                ]}>
                <Input maxLength={128} />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                label='Quantity'
                name="quantity"
                rules={[
                  {
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                label='Charge Type'
                name="chargetype">
                <Select allowClear showSearch
                  onChange = {((e : string) => { setChargeType(e)})}
                >
                  {[
                    { codeName: 'Amount' },
                    { codeName: 'Percent' },
                  ].map((item: any) => {
                    return (
                      <Option
                        key={item.codeName}
                        value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                extra={
                  <span className={styles.tipColor}>
                    Please input the amount value for each charge.
                    Input 0 if free of charge, or leave the field
                    blank if not applicable
                  </span>
                }
                label={`${chargeType ? `Charge (${chargeType})` : `Charge` } `}
                name="charge"
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            {chargeType === 'Amount' && (
            <Col span={13}>
              <Form.Item
                label='Currency'
                name="currency"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch>
                  {curData.map((item: any) => {
                    return (
                      <Option
                        key={item.codeName}
                        value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>)}
            <Col span={13}>
              <Form.Item
                label='Charge Unit'
                name="unit">
                <Select allowClear showSearch>
                  {chgUnitData.map((item: any) => {
                    return (
                      <Option
                        key={item.codeName}
                        value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                label='Charge Frequency'
                name="frequency">
                <Select allowClear showSearch>
                  {chgFrequencyData.map((item: any) => {
                    return (
                      <Option
                        key={item.codeName}
                        value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            </Row>
            <br />
          </Form>
          { disableFlag && <Loading type="large" /> }
          <ActionButtonsBar
            onCancel={props.onClose}
            onSave={() => saveCapacity()}
            disabledSave={disableFlag}
            show={true}
            onDelete={Object.keys(props.currentRow).length > 0 ? () => deleteService() : false}
          />
        </Card>}
        {!ready && <Loading type="medium" />}
      </Drawer>
    </>
  )
}

export default ServiceModal
